/*
 * @Description:规则管理--对象映射规则/接口映射规则
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  启用: '启用',
  停用: '停用',
  字段: '字段',
  规则名称: '规则名称',
  来源对象: '来源对象',
  映射字段: '映射字段',
  规则类型: '规则类型',
  映射类型: '映射类型',
  映射至对象: '映射至对象',
  映射规则设置: '映射规则设置',
  对象映射规则: '对象映射规则',
  新建映射规则: '新建映射规则',
  对象映射规则设置: '对象映射规则设置',
  接口映射规则设置: '接口映射规则设置',
  获取规则详情失败: '获取规则详情失败',
  获取对象列表失败: '获取对象列表失败',
  字段属性: '字段属性',
  '字段属性不能为空,请重新设置': '字段属性不能为空,请重新设置',
  '请设置选项名称(必填)': '请设置选项名称(必填)',
  选项至少保留一项: '选项至少保留一项',
  暂无视图: '暂无视图',
  配置同步规则: '配置同步规则',
  ID关联: 'ID关联',
  主属性字段关联: '主属性字段关联',
  字段映射: '字段映射',
  搜索规则名称: '搜索规则名称',
  新建规则: '新建规则'
};
